import { isFieldEmptyValidation } from './isFieldEmptyValidation';

const emptyFieldValidationMessage = 'Please fill in field correctly';
const categoryNotSelectedValidationMessage = 'Please select a category';

export const validateCategoryId = (categoryId: string) => {
  return isFieldEmptyValidation(
    categoryId,
    categoryNotSelectedValidationMessage
  );
};

export const validateName = (name: string) => {
  return isFieldEmptyValidation(name, emptyFieldValidationMessage);
};

export const validateSharedCode = (sharedCode: string) => {
  return isFieldEmptyValidation(sharedCode, emptyFieldValidationMessage);
};

export const validateSecretKey = (secretKey: string) => {
  return isFieldEmptyValidation(secretKey, emptyFieldValidationMessage);
};
